import { toast } from 'react-toastify'
import { disconnectComprasNotificacionSocket } from './comprasNotificacionSocket'

/**
 * Punto único para reaccionar a un token de sesión vencido/ inválido (401
 * del backend). Limpia la sesión y envía al usuario al login, sin importar
 * si la petición que detectó el vencimiento vino de axios o de fetch.
 */
let handlingExpiration = false

export const handleSessionExpired = () => {
    // Evita redirecciones/duplicados si varias peticiones fallan al mismo tiempo
    if (handlingExpiration) return
    handlingExpiration = true

    try {
        disconnectComprasNotificacionSocket()
    } catch (error) {
        // noop: no bloquear el cierre de sesión por un error del socket
    }

    const hadSession = !!sessionStorage.getItem('token')
    sessionStorage.clear()

    if (hadSession) {
        toast.warn('Tu sesión ha expirado, por favor inicia sesión nuevamente')
    }

    if (window.location.pathname !== '/login') {
        window.location.href = '/login'
    } else {
        handlingExpiration = false
    }
}
